import React, { createContext, useContext } from "react";

interface VideoSpeedAdjustmentContextType {
  /** Ist die automatische Geschwindigkeitsanpassung aktiviert? (immer true, Toggle entfernt) */
  isSpeedAdjustmentEnabled: boolean;
}

const VideoSpeedAdjustmentContext = createContext<
  VideoSpeedAdjustmentContextType | undefined
>(undefined);

/**
 * Provider für die globale Geschwindigkeitsanpassung von Videos
 * Die Anpassung ist immer aktiviert (Toggle-Funktionalität entfernt)
 */
export function VideoSpeedAdjustmentProvider({
  children,
}: {
  children: React.ReactNode;
}): JSX.Element {
  // Geschwindigkeitsanpassung ist immer aktiviert (kein Toggle mehr)
  const isEnabled = true;

  return (
    <VideoSpeedAdjustmentContext.Provider
      value={{
        isSpeedAdjustmentEnabled: isEnabled,
      }}
    >
      {children}
    </VideoSpeedAdjustmentContext.Provider>
  );
}

/**
 * Hook zum Zugriff auf den VideoSpeedAdjustmentContext
 */
export function useVideoSpeedAdjustment(): VideoSpeedAdjustmentContextType {
  const context = useContext(VideoSpeedAdjustmentContext);
  if (context === undefined) {
    throw new Error(
      "useVideoSpeedAdjustment must be used within a VideoSpeedAdjustmentProvider"
    );
  }
  return context;
}
